import type { UseListProps } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import { projectListFragment } from './graphql'
import type { SetOptional } from 'type-fest'
import { gql } from '@apollo/client'

export const projectListQuery = gql`
  query allProject($filter: JSON!, $options: JSON) {
    allProject(filter: $filter, options: $options) {
      ...projectListFragment
    }
    allProjectMeta(filter: $filter) {
      count
    }
  }
  ${projectListFragment}
`

export const useProjectList = ({ listActionOptions = {}, query, ...props }: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? projectListQuery

  const finalDefaultListActions = {
    ...listActionOptions,
    storageType: StorageType.localStorage,
    timeZone,
  }

  return useList({
    query,
    ...props,
    limit: 100,
    sort: { createdAt: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
